export const UPDATE_CART = 'UPDATE_CART';
export const CHANGE_CURRENCY = 'CHANGE_CURRENCY';
export const RESET_DATA = 'RESET_DATA';
